import ApiService from "../apiService";
import { get, patch } from "../apiService";

const model = "tasks";

export default class TaskService extends ApiService {
  findAll(searchTerm) {
    return get(`/${model}`, {
      params: {
        "filter[search]": searchTerm
      }
    });
  }

  save(item) {
    return this.baseSave(model, item);
  }

  archive(item) {
    return this.baseArchive(model, item);
  }
}



// WEBPACK FOOTER //
// ./src/services/taskService/index.js